import React, { ReactElement, useEffect } from "react";
import { MetabaseTrack, identify } from "@metabase/track-react";

interface IProductAnalyticsProps {
  haveConsent?: boolean;
  tag: string;
  user?: Record<string, any>;
  persistence?: boolean;
}

export default function ProductAnalytics({
  haveConsent,
  tag,
  user,
  persistence,
}: IProductAnalyticsProps): ReactElement | null {
  const isBrowser = typeof window !== "undefined";

  useEffect(() => {
    if (isBrowser && haveConsent && user) {
      identify(user.id || user.sid, { user, tag });
    }
  }, [isBrowser, haveConsent, user, tag]);

  // Browser only
  if (!isBrowser) {
    return null;
  }

  return (
    <MetabaseTrack
      website={
        process.env.NEXT_PUBLIC_PA_WEBSITE_ID ||
        "23eefa30-4c4f-490e-aa4f-084cd23b1561"
      }
      tag={tag}
      haveConsent={haveConsent || !!user}
      persistence={persistence}
    />
  );
}
